import Crossfader from "./Crossfader.js";
import VimeoPlayer from "@vimeo/player";

class PlayPause {
    constructor() {
        this.init();
    }

    init() {
        this.buttons = document.querySelectorAll("[data-play-pause]");
        this.crossfaders = document.querySelectorAll("[data-crossfader]");
        this.videos = document.querySelectorAll("[data-autoplay-video] iframe");

        // On click pause all crossfaders and videos on page. Toggle all play pause buttons.
        this.buttons.forEach((button) => {
            button.addEventListener("click", this.toggleMedia.bind(this));
        });
    }

    toggleMedia(e) {
        this.state = e.currentTarget.dataset.playPause;

        this.toggleButtons();
        if (this.crossfaders) this.toggleCrossfaders();
        if (this.videos) this.toggleAutoplayVideos();
    }

    toggleButtons() {
        this.buttons.forEach((button) => {
            if (this.state == "pause") {
                button.dataset.playPause = "play";
            } else {
                button.dataset.playPause = "pause";
            }
        });
    }

    toggleCrossfaders() {
        this.crossfaders.forEach((crossfader) => {
            if (this.state == "pause") {
                clearInterval(crossfader.crossfader_interval);
            } else {
                new Crossfader(crossfader);
            }
        });
    }

    toggleAutoplayVideos() {
        this.videos.forEach((element) => {
            this.player = new VimeoPlayer(element);
            if (this.state == "pause") {
                this.player.pause();
            } else {
                this.player.play();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const button = document.querySelector("[data-play-pause]");
    if (button) new PlayPause();
});
